<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Pressing</h5>
            </b-col>

            <b-col align="right">
                <b-dropdown size="sm" variant="outline-secondary" toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <b-icon-caret-down></b-icon-caret-down>
                    </template>

                    <div v-for="(type, index) in pressingTypes" :key="index">
                        <b-dropdown-item @click="addPressing(type.value)">{{ type.text }}</b-dropdown-item>
                    </div>
                    
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-b-modal.addCountryModal><b-link>Add Country</b-link></b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>

        <b-row v-if="!component.length">
            <b-col align="center">
                <drop @drop="dropPressing($event)" style="width: 100%">
                    <b-list-group>
                        <b-list-group-item variant="light">
                            <small><em>No Pressing Information</em></small>
                        </b-list-group-item>
                    </b-list-group>
                </drop>
            </b-col>
        </b-row>

        <div v-for="(pressing, index) in component" v-bind:key="index">
            <drop @drop="dropPressing($event)" style="width: 100%">
                <b-input-group size="sm">
                    <b-form-select :options="pressingTypes"
                                   v-model="pressing.type"
                                   @change="changeType(pressing.type, index)"
                                   :state="pressing.type && pressing.type.length ? null : false">
                        <template #first>
                            <b-form-select-option :value="undefined" disabled>Type</b-form-select-option>
                        </template>
                    </b-form-select>

                    <b-form-select v-if="pressing.type === 'country'"
                                   :options="countries"
                                   v-model="pressing.text"
                                   :state="pressing.text && pressing.text.length ? null : false"
                                   :ref="'text-' + index"
                                   value-field="name"
                                   text-field="name">
                    </b-form-select>

                    <b-input v-else
                             style="width: 5rem;"
                             :ref="'text-' + index"
                             v-model="pressing.text"
                             :state="pressing.text && pressing.text.length ? null : false">
                    </b-input>

                    <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="removePressing(index)" tabindex="-1">
                            <b-icon-x></b-icon-x>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </drop>
        </div>

        <b-modal id="addCountryModal"
             title="Add Country"
             size="sm"
             button-size="sm"
             hide-footer
             centered>
             <b-input-group>
                <b-input placeholder="Country" v-model="country"  />
                <b-button @click="addCountry" variant="success">Add</b-button>
             </b-input-group>
        </b-modal>
    </div>
</template>

<script>
    import utils from "../../mixins/utils";
    import arrayMixin from "../../mixins/array";
    import pressingTypeOptions from "../../assets/pressingTypeOptions";
    // import countryList from "../../assets/countryList";
    import inventoryApi from "../../api/inventory";

    export default {
        name: "Pressing",
        props: [ 'pressing' ],
        mixins: [ arrayMixin, pressingTypeOptions, inventoryApi, utils ],
        created() {
            this.clone(this.pressing);
        },
        async mounted() {
            await this.fetchCountries();
        },
        data() {
            return {
                typeOptions: [
                    { text: 'Style', value: 'style' }
                ],
                countries: [],
                country: '',
            }
        },
        methods: {
            async fetchCountries() {
                const countries = await this.getCountries();
                this.countries = countries;
            },
            changeType(type, index) {
                if (type) {
                    this.$nextTick(() => {
                        let ref = 'text-' + index;

                        this.$refs[ref][0].$el.focus();
                    });
                }
            },
            addPressing(type) {
                if (!type) {
                    this.component.push({text: ''});
                } else {
                    let index = this.component.length;
                    this.$set(this.component, index, {text: '', type: type});

                    this.$nextTick(() => {
                        let ref = 'text-' + index;

                        this.$refs[ref][0].$el.focus();
                    });
                }
            },
            removePressing(index) {
                this.component.splice(index, 1);
            },
            dropPressing(note) {
                let type = null;

                if (note === '(Mono)') {
                    type = 'fidelity';
                    note = 'Mono';
                }

                this.component.push({ text: note, type: type });
                this.handleNoteDrop(note);
            },
            handleNoteDrop(note) {
                this.$emit('dropNote', note);
            },
            async addCountry() {
                if (this.country.length > 1) {
                    const country = this.country;
                    await this.createCountry(country);
                    await this.fetchCountries();
                    this.country = '';
                    this.$bvModal.hide('addCountryModal');
                    this.showToast('Country Added', country);
                }
            }
        },
        computed: {
            hasGenre() {
                for (let i = 0; i < this.component.length; i++) {
                    if (!this.component[i].type) {
                        return true;
                    }
                }

                return false;
            }
        }
    }
</script>

<style scoped>
    .dropdown-button {
        padding: 0;
    }
</style>